/* Effico cart timer: "Je winkelwagen is gereserveerd voor [timer] minuten".
   Als custom element zodat hij ook na een her-render van de cart drawer gewoon doorloopt.
   Gedrag zoals het oude thema: eerste fase (duration, standaard 5:00), daarna een korte
   tweede fase van 1:30, daarna blijft 0:00 staan. Starttijd bewaard in sessionStorage. */
(function () {
  if (customElements.get('effico-cart-timer')) return;
  const KEY = 'effico-cart-timer-start';
  const PHASE2 = 90;
  class EfficoCartTimer extends HTMLElement {
    connectedCallback() {
      this.duration = parseInt(this.dataset.duration || '300', 10);
      this.template = this.dataset.text || '[timer]';
      this.out = this.querySelector('[data-timer-text]') || this;
      this.reset = this.dataset.reset === 'true';
      let start = 0;
      try { start = parseInt(sessionStorage.getItem(KEY) || '0', 10); } catch (e) { start = 0; }
      const now = Date.now();
      if (!start || this.reset || now - start > (this.duration + PHASE2) * 1000 * 4) {
        start = now;
        try { sessionStorage.setItem(KEY, String(start)); } catch (e) {}
      }
      this.start = start;
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    tick() {
      const elapsed = Math.floor((Date.now() - this.start) / 1000);
      let remaining;
      if (elapsed < this.duration) remaining = this.duration - elapsed;
      else if (elapsed < this.duration + PHASE2) remaining = this.duration + PHASE2 - elapsed;
      else remaining = 0;
      const m = Math.floor(remaining / 60);
      const s = String(remaining % 60).padStart(2, '0');
      this.out.innerHTML = this.template.replace('[timer]', `<span class="effico-cart-timer__value">${m}:${s}</span>`);
    }
  }
  customElements.define('effico-cart-timer', EfficoCartTimer);
  // Timer opnieuw starten zodra er iets aan de winkelwagen wordt toegevoegd (zoals het oude thema)
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.subscribe || !window.PUB_SUB_EVENTS) return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      if (e && e.source === 'product-form') {
        try { sessionStorage.setItem(KEY, String(Date.now())); } catch (err) {}
        document.querySelectorAll('effico-cart-timer').forEach((t) => { t.start = Date.now(); t.tick(); });
      }
    });
  });
})();
